<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loading.page">
    <a-card class="m-display-flex flex-column nowrap">
      <span slot="title">Create PBK</span>
      <a-steps :current="current" status="process">
        <a-step title="Request PBK" />
        <a-step title="Plan PBK"/>
      </a-steps>
      <div class="steps-content flex-1">
        <keep-alive>
          <component
            class="flex-1"
            :is="steps[current].content"
            :ref="stepRef"
            v-bind="stepProps"
          ></component>
        </keep-alive>
      </div>
      <template slot="actions">
        <div class="steps-action">
          <a-button type="primary" v-if="current < steps.length - 1" @click="next">Next</a-button>
          <a-button type="primary" v-if="current == steps.length - 1" @click="next">Save</a-button>
          <a-button v-if="current > 0" @click="prev">Previous</a-button>
        </div>
      </template>
    </a-card>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import RequestPBK from "./steps/RequestPBK";
import PlanPBK from "./steps/PlanPBK";
import GlobalMethod from "@/mixins/GlobalMethod";
import moment from "moment";

export default {
  name: "CreatePBK",
  components: {
    RequestPBK,
    PlanPBK,
  },
  mixins: [GlobalMethod],
  data() {
    return {
      loading: {
        page: false
      },
      mode: "Create",
      current: 0,
      steps: [
        {
          title: "Request PBK",
          content: "RequestPBK",
        },
        {
          title: "Plan PBK",
          content: "PlanPBK",
        },
      ],
      collectData: {
        requestPBK: [],
        planPBK: [],
      },
    }
  },
  mounted() {
    Event.$on("dataPBK", this.valueFromChild);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("dataPBK", this.valueFromChild);
    Event.$off("confirmMessageReturn", this.submit);
  },
  computed: {
    ...mapGetters(["getAuth"]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "RequestPBK") {
          return {
            // collectData: this.collectData,
            // id: this.id,
            // tipe: this.tipeTrans,
            // catatan: this.note,
            // catatanOri: this.noteOri,
          };
        } else {
          return {
            // collectData: this.collectData,
            // id: this.id,
            // catatan: this.note,
            // catatanOri: this.noteOri,
          };
        }
      } else {
        if (this.steps[this.current].content === "RequestPBK") {
          return {
            // collectData: this.collectData,
            // catatan: this.note,
            // catatanOri: this.noteOri,
          };
        } else {
          return {
            // collectData: this.collectData,
            // catatan: this.note,
            // catatanOri: this.noteOri,
          };
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "RequestPBK") {
        return "refRequestPbk";
      } else {
        return "refPlanPbk";
      }
    },
  },
  methods: {
    moment,
    prev() {
      this.current--;
    },
    next() {
      if (this.steps[this.current].content === "RequestPBK") {
        this.$refs.refRequestPbk.handleRef();
      } else {
        this.$refs.refPlanPbk.handleRef();
      }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "RequestPBK") {
        this.collectData.requestPBK = JSON.parse(JSON.stringify(value.values))
        this.current++;
      } else {
        this.collectData.planPBK = value.values
        this.confirmMessage("confirm-save");
      }
    },
    submit() {
      this.loading.save = true;

      let data = new FormData();
      data.append("request_dt", this.collectData.requestPBK.request_dt);
      data.append("ntpn_no", this.collectData.requestPBK.ntpn);
      data.append("tax_type_from", this.collectData.requestPBK.tax_type);
      data.append("tax_masa_from", moment(this.collectData.requestPBK.month_year, "YYYY-MM").format("MM-YYYY"));
      data.append("kap_from", this.collectData.requestPBK.kap);
      data.append("kjs_from", this.collectData.requestPBK.kjs);
      data.append("value_request_pbk", this.collectData.requestPBK.value);
      data.append("tax_type_to", this.collectData.planPBK.tax_type);
      data.append("tax_masa_to", moment(this.collectData.planPBK.month_year, "YYYY-MM").format("MM-YYYY"));
      data.append("kap_to", this.collectData.planPBK.kap);
      data.append("kjs_to", this.collectData.planPBK.kjs);
      data.append("value_plan_pbk", this.collectData.planPBK.value);
      data.append("request_note", this.collectData.planPBK.note);
      if(this.collectData.planPBK.file_document_tax)
        data.append("doc_pbk_req", this.collectData.planPBK.file_document_tax);

      this.asyncAxiosPost("pbk", "formdata", this.getAuth, data)
      .then((response) => {
        this.loading.save = false;
        if (response.status && response.status == true) {
          this.displayMessageValue("success-other", response.message);
          this.$router.push({
            name: "pbk",
            params: {},
          });
        } else {
          let responses = Object.assign({}, response);
          this.displayMessageValue("error-other", responses);
        }
      })
      .catch((err) => {
        this.loading.save = false;
        let responses = Object.assign({}, err.response);
        this.displayMessageValue("error-other", responses.message);
      });
    }
  }
}
</script>